import React from "react";

// Styles

import "./Styles.scss";

export default function OutsideWorkHours() {
  return (
    <div className="page-wrapper">
      <div className="container">
        <div className="onboarding-page">
          <div className="onboarding-wrapper">
            <h1>Estimado cliente:</h1>

            <p>
              Nuestro servicio de Solicitud de Cuenta se encuentra disponible todos los días, <br />
              en el horario comprendido entre las <strong>7:00 a.m.</strong>
              a <strong>10:00 p.m.</strong>
            </p>

            <p>
              Te esperamos para que vivas la Experiencia Digital Bancaribe.
            </p>

            <p>
              <strong>¡Hazlo fácil, hazlo digital!</strong>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
